import moment from 'moment';
import * as types from '../../constants/actionsType';
import Colors from '../../../utils/constants/Colors';

const initialState = {
  summaryCard: [],
  dayWiseTrend: [],
  isLoadingDayWiseTrend: true,
  attendanceTrend: [],
  isLoadingAttendanceTrend: true,
  categoryList: {
    head: [],
    body: []
  },
  isLoadingCategoryList: true,
  appWebList: [],
  isLoadingAppWebList: true,
  categoryAppWeb: [],
  isLoadingCategoryAppWeb: false,
  timeLineBar: [],
  timeLine: [],
  isLoadingTimeLine: true,
  calendarDetails: [],
  isAgentAvailable: true,
  isShowNotificationDailyTrend: true,
  isAssetDetailsLoading: false,
  AssetDetails: [],
  holidayDetails: [{ head: [], body: [] }],
  isLoadingHolidayDetails: false,

}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_DASHBOARD_SUMMARY:

      var data = [];
      if (action.data.length > 0) {
        data = [
          { name: 'Average Capacity Hrs', unitBefore: action.data[0].capHrs.replace(":", "."), unitAfter: '', color: Colors.productive, icon: "Clock", fill: '#000', background: 'rgba(87,113,219,0.05)' },
          { name: 'Average Logged in Hrs', unitBefore: action.data[0].avgLogHrs.replace(":", "."), unitAfter: action.data[0].avgLogPer + "%", color: Colors.productive, icon: "In", background: 'rgba(87,113,219,0.05)' },
          { name: 'Average Active Hrs', unitBefore: action.data[0].avgActHrs.replace(":", "."), unitAfter: action.data[0].avgActPer + "%", color: Colors.productive, icon: "User", background: 'rgba(87,113,219,0.05)' },
          { name: 'Average Productive Hrs', unitBefore: action.data[0].avgProdHrs.replace(":", "."), unitAfter: action.data[0].avgProdPer + "%", color: Colors.productive, icon: "Clock2", background: 'rgba(87,113,219,0.05)' },
          { name: 'Average Desk-Away Hrs', unitBefore: action.data[0].avgIdlHrs.replace(":", "."), unitAfter: action.data[0].avgIdlPer + "%", color: Colors.productive, icon: "Desk", background: 'rgba(87,113,219,0.05)' },
          // { name: 'Average In-Time', unitBefore: action.data[0].avgIn, unitAfter: '' },
          // { name: 'Average Out-Time', unitBefore: action.data[0].avgOut, unitAfter: '' }
          { name: ['Average In / Out Time'], unitBefore: action.data[0].avgIn.length > 0 ? action.data[0].avgIn + '/' + action.data[0].avgOut : "", unitAfter: '' }
        ]
      }
      return {
        ...state,
        summaryCard: data
      }
    case types.SUCCESS_DASHBOARD_SUMMARY_SINGLE_DATE:
      var data = [];
      if (action.data.length > 0) {
        data = [
          { name: 'Capacity Hrs', unitBefore: action.data[0].capHrs.replace(":", "."), unitAfter: '', color: Colors.productive, icon: "Clock", fill: '#000', background: 'rgba(87,113,219,0.05)' },
          { name: 'Logged in Hrs', unitBefore: action.data[0].avgLogHrs.replace(":", "."), unitAfter: action.data[0].avgLogPer + "%", color: Colors.productive, icon: "In", background: 'rgba(87,113,219,0.05)' },
          { name: 'Active Hrs', unitBefore: action.data[0].avgActHrs.replace(":", "."), unitAfter: action.data[0].avgActPer + "%", color: Colors.productive, icon: "User", background: 'rgba(87,113,219,0.05)' },
          { name: 'Productive Hrs', unitBefore: action.data[0].avgProdHrs.replace(":", "."), unitAfter: action.data[0].avgProdPer + "%", color: Colors.productive, icon: "Clock2", background: 'rgba(87,113,219,0.05)' },
          { name: 'Desk-Away Hrs', unitBefore: action.data[0].avgIdlHrs.replace(":", "."), unitAfter: action.data[0].avgIdlPer + "%", color: Colors.productive, icon: "Desk", background: 'rgba(87,113,219,0.05)' },
          { name: ['In / Out Time'], unitBefore: action.data[0].avgIn.length > 0 ? action.data[0].avgIn + '/' + action.data[0].avgOut : "", unitAfter: '' }
        ]
      }
      return {
        ...state,
        summaryCard: data
      }
    case types.SUCCESS_DAY_WISE_TREND:
      return {
        ...state,
        dayWiseTrend: action.data,
        isLoadingDayWiseTrend: false
      }
    case types.FAILED_DAY_WISE_TREND:
      return {
        ...state,
        dayWiseTrend: [],
        isLoadingDayWiseTrend: false
      }

    case types.SUCCESS_ATTENDANCE_TREND:
      return {
        ...state,
        attendanceTrend: action.data,
        isLoadingAttendanceTrend: false
      }
    case types.FAILED_ATTENDANCE_TREND:
      return {
        ...state,
        attendanceTrend: [],
        isLoadingAttendanceTrend: false
      }

    case types.SUCCESS_CATEGORY_LIST:
      var data = action.data.map(i => {
        return [i.cat, i.timeSpent, i.timePer, i.catId]
      })
      return {
        ...state,
        categoryList: {
          head: [
            { label: "Categories", align: "left" },
            { label: "Hours Spent", align: "right" },
            { label: "Time Spent %", align: "right" },
          ],
          body: data
        },
        isLoadingCategoryList: false
      }
    case types.FAILED_CATEGORY_LIST:
      return {
        ...state,
        categoryList: {
          head: [],
          body: []
        },
        isLoadingCategoryList: false
      }

    case types.SUCCESS_APP_WEB_LIST:
      var data = []
      if (action.data.catAppWebList != undefined && action.data.catAppWebList != null) {
        var data = action.data.catAppWebList.map(i => {
          return { id: i.appId, name: i.appName, hours: i.timeSpent, image: i.appLogo, application: i.isWeb ? 0 : 1, isProd: i.isProd }
        })
      }
      return {
        ...state,
        appWebList: data,
        isLoadingAppWebList: false
      }
    case types.FAILED_APP_WEB_LIST:
      return {
        ...state,
        appWebList: [],
        isLoadingAppWebList: false
      }
      case types.LOADING_CATEGORY_APP_WEB:
        return {
          ...state,
          isLoadingCategoryAppWeb: true
        }
    case types.SUCCESS_CATEGORY_APP_WEB:
      return {
        ...state,
        categoryAppWeb: action.data,
        isLoadingCategoryAppWeb: false
      }
    case types.FAILED_CATEGORY_APP_WEB:
      return {
        ...state,
        categoryAppWeb: [],
        isLoadingCategoryAppWeb: false
      }

    case types.SUCCESS_TIMELINE:
      var bar = action.data.prodBarList.map(i => {
        return {
          fromDate: moment(new Date(0, 0, 0, i.hrs, parseInt(i.min.toString() + "0"), 0)).format("HH:mm"),
          date: moment(new Date(0, 0, 0, i.hrs, parseInt(i.min.toString() + "0"), 0)).format("HH:mm") + "-" + moment(new Date(0, 0, 0, i.hrs, parseInt(i.min.toString() + "0") + 10, 0)).format("HH:mm"),

          per: (((parseFloat(i.per) * 600) / 100) / 60).toFixed(2),
          idleTime: (((parseFloat(i.idlePer) * 600) / 100) / 60).toFixed(2),
          offlineTime: (((parseFloat(i.offlinePer) * 600) / 100) / 60).toFixed(2),
          idlePer: i.idlePer,
          totalPer: i.totalPer,
          offline: i.offlinePer,
          child: action.data.prodBarDetail.filter(item => item.hrs == i.hrs && item.min == i.min)
        }
      }).sort((a, b) => a.fromDate > b.fromDate ? 1 : -1)

      var timelineBar = action.data.prodBarList.map(i => {
        return {
          ...i, child: action.data.prodBarDetail.filter(item => item.hrs == i.hrs && item.min == i.min)
        }
      })

      var chart = [
        { type: 'string', id: 'Date' },
        { type: 'string', id: 'dummy bar label' },
        { type: 'string', role: 'tooltip', p: { html: true, trigger: 'none' } },
        { type: 'date', id: 'Start' },
        { type: 'date', id: 'End' },
      ]
      var timeLine = timelineBar.map((i, index) => {
        return [
          '03-Feb-21',
          i.child.length != 0 ? i.offlinePer != "0.00" ? "   " : "  " : "",
          // i.child.length == 0 ? "" : "  ",
          "",
          new Date(0, 0, 0, i.hrs, parseInt(i.min.toString() + "0"), 0),
          new Date(0, 0, 0, i.hrs, parseInt(i.min.toString() + "0") + 10, 0),
        ]
      }).sort((a, b) => moment(a[3]) > moment(b[3]) ? 1 : -1)
      return {
        ...state,
        timeLineBar: bar,
        timeLine: timeLine.length > 0 ? [chart, ...timeLine] : [],
        isLoadingTimeLine: false
      }
    case types.FETCH_TIMELINE:
      return {
        ...state,
        timeLineBar: [],
        timeLine: [],
        isLoadingTimeLine: true
      }
    case types.FAILED_TIMELINE:
      return {
        ...state,
        timeLineBar: [],
        timeLine: [],
        isLoadingTimeLine: false
      }
    case types.SUCCESS_HOURLY_TIMELINE:
      var bar = action.data.prodBarList.map(i => {
        return {
          fromDate: moment(new Date(0, 0, 0, i.hrs, 0, 0)).format("HH:mm"),
          date: moment(new Date(0, 0, 0, i.hrs, 0, 0)).format("HH:mm") + "-" + moment(new Date(0, 0, 0, parseInt(i.hrs) + 1, 0, 0)).format("HH:mm"),
          per: (parseFloat(i.timeSpt) / 60).toFixed(2),
          idleTime: ((parseFloat(i.idleTime)) / 60).toFixed(2),
          offlineTime: ((parseFloat(i.offlinePer) * 60) / 100),
          totalPer: i.totalPer,
          idlePer: i.idlePer,
          offline: i.offlinePer,
          child: action.data.prodBarDetail.filter(item => item.hrs == i.hrs && item.min == i.min)
        }
      }).sort((a, b) => a.fromDate > b.fromDate ? 1 : -1)
      var timelineBar = action.data.prodBarList.map(i => {
        return {
          ...i, child: action.data.prodBarDetail.filter(item => item.hrs == i.hrs && item.min == i.min)
        }
      })

      var chart = [
        { type: 'string', id: 'Date' },
        { type: 'string', id: 'dummy bar label' },
        { type: 'string', role: 'tooltip', p: { html: true, trigger: 'none' } },
        { type: 'date', id: 'Start' },
        { type: 'date', id: 'End' },
      ]
      var timeLine = timelineBar.map(i => {
        var a = i.child.map(i => {
          return "<p>" + i.app + "</p>"
        })
        return [
          '03-Feb-21',
          i.child.length != 0 ? i.offlinePer != "0.00" ? "   " : "  " : "",
          "",
          new Date(0, 0, 0, i.hrs, 0, 0),
          new Date(0, 0, 0, parseInt(i.hrs) + 1, 0, 0),
        ]
      })

      return {
        ...state,
        timeLineBar: bar,
        timeLine: timeLine.length > 0 ? [chart, ...timeLine] : [],
        isLoadingTimeLine: false
      }
    case types.FAILED_HOURLY_TIMELINE:
      return {
        ...state,
        timeLineBar: [],
        timeLine: [],
        isLoadingTimeLine: false
      }
    case types.SHOW_LOADER:
      return {
        ...state,
        summaryCard: [],
        dayWiseTrend: [],
        isLoadingDayWiseTrend: true,
        attendanceTrend: [],
        isLoadingAttendanceTrend: true,
        categoryList: {
          head: [],
          body: []
        },
        isLoadingCategoryList: true,
        appWebList: [],
        isLoadingAppWebList: true,
        categoryAppWeb: [],
        //isLoadingCategoryAppWeb: true,
        timeLineBar: [],
        timeLine: [],
        isLoadingTimeLine: true,
      }
    case types.CALENDAR_DETAILS:
      var data = [];

      if (action.data.length > 0) {
        action.data.forEach(element => {
          var date = (new Date() - new Date(element.date));
          if (date > 0) {
            data.push({
              "date": element.date,
              "products": {
                "tTime": element.tTime,
                "aTime": element.aTime,
                "pTime": element.pTime,
                "checkIn": element.checkIn,
                "checkOut": element.checkOut,
                "dAvail": element.dAvail,
                "date": element.date,
                "remark": element.remark
              }
            })
          }
        });

      }
      return {
        ...state,
        calendarDetails: data
      }
    case types.FAILED_CALENDAR_DETAILS:
      return {
        ...state,
        calendarDetails: []
      }

    case types.IS_AGENT_AVAILABLE: {

      return {
        ...state,
        isAgentAvailable: action.data
      }
    }
    case types.HIDE_NOTIFICATION_DAILY_TREND:
      return {
        ...state,
        isShowNotificationDailyTrend: false
      }
    case types.UPDATE_TIMELINE:
      // console.log("kkk", action.fromDate, state.timeLineBar)

      var data = state.timeLineBar.map(i => {
        if (moment(action.fromDate, "HH:mm").format("HH:mm") <= moment(i.fromDate, "HH:mm").format("HH:mm") && moment(action.toDate, "HH:mm").format("HH:mm") > moment(i.fromDate, "HH:mm").format("HH:mm")) {
          // console.log("ok", moment(i.fromDate, "HH:mm").format("HH:mm"), moment(action.fromDate, "HH:mm").format("HH:mm"))
          return { ...i, offline: "100", per: "0", idlePer: "0" }
        }
        return { ...i }
      })

      var barData = state.timeLine
      var chartData = barData.map((i, index) => {
        if (index != 0) {
          if (moment(action.fromDate, "HH:mm").format("HH:mm") <= moment(i[3]).format("HH:mm") && moment(action.toDate, "HH:mm").format("HH:mm") > moment(i[3]).format("HH:mm")) {
            var dateChange = i
            dateChange[1] = "   "
            return dateChange
          } else {
            return i
          }
        } else {
          return i
        }
      })

      return {
        ...state,
        timeLineBar: data,
        timeLine: chartData
      }
    case types.LOADING_ASSET_DETAILS: {

      return {
        ...state,
        isAssetDetailsLoading: action.data
      }
    }
    case types.FAILED_ASSET_DETAILS: {

      return {
        ...state,
        AssetDetails: []
      }
    }
    case types.SUCCESS_ASSET_DETAILS: {
      var data = []
      action.data.map(i => {
        data.push({ systemName: i.systemName, loginName: i.loginName, agentCreatedOn: i.agentCreatedOn, lastDataAvailable: i.lastDataAvailable ,agentVersion:i.agentVersion})
      })
      return {
        ...state,
        AssetDetails: data
      }
    }

    case types.FETCH_HOLIDAY_DETAILS_FOR_MYDASHBOARD: {

      return {
        ...state,
        holidayDetails: [],
        isLoadingHolidayDetails: true,
      }
    }
    case types.GET_HOLIDAY_DETAILS_FOR_MYDASHBOARD: {
      var data = []
      action.data.map(i => {
        data.push([i.holidayDate,i.holidayDescription, i.leaveType])
      })
      return {
        ...state,
        holidayDetails: {
          head: [
            { label: "Holiday Date", align: "left" },
            { label: "Holiday Description", align: "left" },
            { label: "Leave Type ", align: "left" },
          ],
          body: data,
        },
        isLoadingHolidayDetails: false,
      }
    }
    case types.FAILED_HOLIDAY_DETAILS_FOR_MYDASHBOARD: {

      return {
        ...state,
        holidayDetails: [],
        isLoadingHolidayDetails: false,
      }
    }
    default:
      return state
  }
}
export default reducer
